import React, { useState, useEffect, useRef } from "react";
import {
  Box,
  Typography,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  CircularProgress,
} from "@mui/material";

const Title1Widget = ({ widget, onValueUpdate }) => {
  const [title, setTitle] = useState(widget.title);
  const [subtitle, setSubtitle] = useState(widget.subtitle);
  const [titleLength, setTitleLength] = useState(0); // 0: normal, 1: bit long, 2: too long
  const titleRef = useRef(null);

  useEffect(() => {
    setTitle(widget.title);
    setSubtitle(widget.subtitle);
  }, [widget.title, widget.subtitle]);

  useEffect(() => {
    // Check if the title is too long for one line
    if (titleRef.current) {
      setTimeout(() => {
        const element = titleRef.current;
        const ratio = element.scrollWidth / element.clientWidth;
        if (ratio <= 1) {
          setTitleLength(0); // normal
        } else if (ratio <= 1.2) {
          setTitleLength(1); // bit long
        } else {
          setTitleLength(2); // too long
        }
      }, 0);
    }
  }, [title, titleRef]);

  return (
    <>
      <Box
        className="card-title-trigger"
        sx={{
          width: "100%",
          height: "100%",
          display: "flex",
          flexDirection: "column",
          alignItems: "flex-start",
          cursor: "pointer",
        }}
      >
        <Typography
          ref={titleRef}
          variant="h2"
          sx={{
            overflow: "hidden",
            textOverflow: titleLength === 2 ? "clip" : "ellipsis",
            whiteSpace: titleLength === 2 ? "normal" : "nowrap",
            fontSize:
              titleLength === 0 ? "18px" : titleLength === 1 ? "16px" : "14px",
            fontWeight: 500,
            lineHeight: titleLength === 2 ? 1 : 1,
            height: titleLength === 2 ? "80%" : "70%",
            alignItems: titleLength === 2 ? "flex-start" : "center",
            width: "100%",
            WebkitLineClamp: titleLength === 2 ? 2 : 1,
            WebkitBoxOrient: "vertical",
            display: titleLength === 2 ? "-webkit-box" : "flex",
          }}
        >
          {title}
        </Typography>
        <Typography
          variant="subtitle1"
          sx={{
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
            width: "100%",
            fontSize:
              titleLength === 2 ? "8px" : titleLength === 1 ? "9px" : "10px",
            lineHeight: 1,
            height: titleLength === 2 ? "20%" : "30%",
            display: "flex",
            alignItems: "center",
          }}
        >
          {subtitle}
        </Typography>
      </Box>
    </>
  );
};

export default Title1Widget;
